import { log } from '@unanet/sdk';
import type { PassportApplication } from '@unanet/unafy';

// see U20-13965
const LOCAL_STORAGE_KEY = 'unanet:webComponent:unanet-app-launcher';

const getCachedPassportApps = (): Record<number, PassportApplication[]> => {
  try {
    const appsByUser = localStorage.getItem(LOCAL_STORAGE_KEY);
    const apps: Record<number, PassportApplication[]> = appsByUser
      ? JSON.parse(appsByUser)
      : {};
    return apps;
  } catch (e) {
    // in case JSON.parse fails
    log.warn({
      msg: 'Error getting passport apps from local storage',
      error: `${e}`,
    });
    return {};
  }
};

export const deleteCachedPassportAppsForAllUsers = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};

export const getCachedPassportAppsForUser = (
  userKey: number | undefined
): PassportApplication[] | null => {
  const appsByUser = getCachedPassportApps();
  return appsByUser[userKey ?? -1] ?? null;
};

export const setCachedPassportAppsForUser = ({
  apps,
  userKey,
}: {
  apps: PassportApplication[];
  userKey: number | undefined;
}) => {
  if (!userKey) {
    return;
  }

  try {
    const data = { ...getCachedPassportApps(), [userKey]: apps };
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    // in case JSON.stringify fails
    log.warn({
      msg: 'Error storing passport apps in local storage',
      error: `${e}`,
    });
  }
};
